import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import DF from 'DisplayFramework';
import Button from 'components/Button';
import ParListSelect from 'components/ParListSelect';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';

import RouterLink from 'components/RouterLink';
import moment from 'moment';
import {
  CollectionResponse,
  findCollectionByanyRef,
} from 'services/collection';
import CollectionStatusTag from './CollectionStatusTag';
import ThirdPartyInput from 'components/ThirdPartyInput';
import AuthorizedUsersInput from 'components/AuthorizedUsersInput';
import IActions from 'icons/IActions';
import { Typography } from 'antd';
export type CollectioListModalProps = {
  onSelect?: (item: CollectionResponse) => void;
  tpid?: number;
};
const CollectionListModal = (props: CollectioListModalProps) => {
  const { onSelect, tpid } = props;
  const [searchs, setsearchs] = useState(tpid ? true : false);

  const [searchParams, setSearchParams] = useState({
    colreference: '',
    colstatus: '',
    coluserid: 0,
    tpidclient: tpid ?? 0,
  });
  const {
    data: collection,
    isFetching,
    refetch,
  } = useQuery(
    ['findCollectionByanyRef', searchParams],
    () => findCollectionByanyRef(searchParams).then((res) => res.list || []),
    { enabled: searchs }
  );

  const columns = useMemo<DataGridColDef<CollectionResponse>[]>(
    () => [
      {
        filtrable: true,
        dataIndex: 'colreference',
        render: (value, record) => {
          if (onSelect) {
            return (
              <Typography.Link onClick={() => onSelect(record)}>
                {value}
              </Typography.Link>
            );
          } else {
            <RouterLink to={`collection/${record.colid}`}>{value}</RouterLink>;
          }
        },
        fixed: 'left',
        width: '8%',
      },
      {
        dataIndex: 'collabel',
        width: '10%',
      },
      {
        filtrable: true,
        comcode: 'tpname',
        filterComponent: (
          <>
            <div></div>
            <ThirdPartyInput
              onChange={(e) => {
                setSearchParams({
                  ...searchParams,
                  tpidclient: e.tpid,
                });
              }}
              role="CLIENT"
            />
          </>
        ),
        dataIndex: 'tpidclient',
        render: (value, record) => record.tpname,
        width: '10%',
      },
      {
        filtrable: true,
        comcode: 'colmanagerName',
        filterComponent: <AuthorizedUsersInput />,
        dataIndex: 'coluserid',
        render: (value, record) => record.colmanagerName,
        width: '10%',
      },
      {
        dataIndex: 'colassigndate',
        width: '10%',
        render: (e) =>
          e !== null && e !== '' ? moment(e).format('YYYY-MM-DD') : '',
      },

      {
        dataIndex: 'colstartdate',
        width: '10%',
        render: (e) =>
          e !== null && e !== '' ? moment(e).format('YYYY-MM-DD') : '',
      },
      {
        dataIndex: 'colenddate',
        width: '10%',
        render: (e) =>
          e !== null && e !== '' ? moment(e).format('YYYY-MM-DD') : '',
      },
      {
        comcode: 'colstatusLabel',
        dataIndex: 'colstatus',
        filtrable: true,
        filterComponent: <ParListSelect parcode="COLSTATUS" />,

        render: (colstatus, record) => (
          <CollectionStatusTag
            status={colstatus}
            statuslabel={record.colstatusLabel}
            key={colstatus}
          />
        ),
        width: '10%',
      },
      { dataIndex: 'colcomment', width: '10%' },
      {
        comcode: 'actions',
        key: 'actions',
        fixed: 'right',
        width: '10%',
        render: (value, record) => (
          <TasksListPopover
            entityId={Number(record.colid)}
            entityName="COLLECTION"
            entityReference={record.colreference}
            title={record?.colreference + ' - ' + record?.tpname}
            onClose={refetch}
          >
            <Button
              size="small"
              comcode="actions"
              icon={<IActions width="18px" heigth="18px" />}
            />
          </TasksListPopover>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refetch]
  );
  return (
    <DF.Provider pagcode="collist">
      <DataGrid
        columns={columns}
        hideExtraAction={!!onselect}
        titleComcode="collectionlist"
        dataSource={collection}
        initialSearchValues={searchParams}
        onSearch={(values) => {
          setSearchParams(values);
          setsearchs(true);
        }}
        isLoading={isFetching}
        rowKey={(record) => record.colid}
        size="small"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1400, y: 400 }}
      />
    </DF.Provider>
  );
};

export default CollectionListModal;
